import React, { useEffect } from "react";
import { UPDATE_USER_PROFILE, GET_USER_PROFILE } from '../../queries';
import { Layout } from "./Layout";
import { TitleSource } from './teleporters/Title';
//import { useParams } from "react-router-dom";
import { useState } from "react";
import '../../styles/Admin.scss';

export const Profile = (props:any) => {

    const [_name, _setName] = useState("");

    useEffect(() => {
        // code to run on component mount
        var dataForGet = {
            id: props.currentUser.userId
        }
        props.client.query({
        
        query: GET_USER_PROFILE,
        variables: dataForGet,
        optimisticResponse: null
        }).then((result:any) => {
            _setName(result.data.syncarto_app_user[0].name)
        });
    }, []) // <-- Pass an empty array as second parameter to useEffect in order to emulate functionality of React class' componentDidMount. We only want to get the user profile once.  

    const handleSetName = (e:any) => {
        _setName(e);
    }

    const handleSubmit = (e:any) => {
        var dataForSave = {
            id: props.currentUser.userId,
            data: {
              name: _name 
            }
          }
        props.client.mutate({
            mutation: UPDATE_USER_PROFILE,
            variables: dataForSave,
            optimisticResponse: null
        }).then((result:any) => {
            console.log("Profile > result,", result)
        });
        e.preventDefault();
    }

    return (
        <Layout {...props}>
           <TitleSource>User Profile</TitleSource>
           <div className="form-parent-div">
                <form onSubmit={e => { handleSubmit(e) }}>
                    <label>Name:</label>
                    <br />
                    <input 
                        name='name' 
                        type='text' 
                        value={_name}
                        onChange={e => handleSetName(e.target.value)}
                    />
                    <br />
                    <br />
                    <input 
                        type='submit' 
                        value='Save' 
                    />
                </form>
            </div>
        </Layout>
    );
}